export default __webpack_public_path__ + "static/media/dcp.7476b89b.svg";